export const DEAL_SECTION_KEYS = {
  GENERAL_INFORMATION: "general-information",
  INTEGRATIONS: "integrations",
  ORGANIZATION: "ORGANIZATION",
  DISPOSITION_SETTINGS: "DISPOSITION_SETTINGS",
  UNDERWRITING_ASSUMPTIONS: "UNDERWRITING_ASSUMPTIONS",
  CASHFLOW_ASSUMPTIONS: "CASHFLOW_ASSUMPTIONS"

};

export const getTitleGroup = sectionKey => {
  switch (sectionKey) {
    case DEAL_SECTION_KEYS.GENERAL_INFORMATION:
      return {
        title: "General Information",
        key: DEAL_SECTION_KEYS.GENERAL_INFORMATION,
        isTitleGroup: true
      };
  }
};
